import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Cart, CART_NORMALIZER } from '@spartacus/cart/base/root';
import { OccCheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/occ';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

import { DpUserPurchaseNumberStateService } from '../services';

// Overridden in order to change PUT url
@Injectable()
export class DpOccCheckoutPaymentTypeAdapter extends OccCheckoutPaymentTypeAdapter {
  constructor(
    http: HttpClient,
    occEndpoints: OccEndpointsService,
    converter: ConverterService,
    private readonly upNumberService: DpUserPurchaseNumberStateService,
  ) {
    super(http, occEndpoints, converter);
  }

  setPaymentType(userId: string, cartId: string, paymentType: string, purchaseOrderNumber?: string): Observable<Cart> {
    return this.http
      .put(this.getSetCartPaymentTypeEndpoint(userId, cartId, paymentType, purchaseOrderNumber), {
        orderOpenText: this.upNumberService.state,
      })
      .pipe(this.converter.pipeable(CART_NORMALIZER));
  }
}
